import { injectReducer } from '../../store/reducers';

export const RegisterAgency = store => (
  {
    path: 'agency/register',
    /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      const Register = require('./containers/RegisterContainer').default;
      const reducer = require('./modules/register').default;

      injectReducer(store, { key: 'register', reducer });
      /*  Return getComponent   */
      cb(null, Register);
    },
  }
);

export default store => (
  {
    path: 'agency',
    /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      const Agency = require('./containers/AgencyContainer').default;
      const reducer = require('./modules/agency').default;

      injectReducer(store, { key: 'agency', reducer });
      /*  Return getComponent   */
      cb(null, Agency);
    },
  }
);



// WEBPACK FOOTER //
// src/routes/agency/index.js